import { IRemittanceRepository, IGetRemittanceItemCountParams, IRemittanceItemCountRepositoryResponse } from "@/core/repositories/remittance";

export class GetRemittanceItemCountUseCase {
  constructor(private readonly remittanceRepository: IRemittanceRepository) {}

  async execute(params: IGetRemittanceItemCountParams, refetch: boolean = false): Promise<IRemittanceItemCountRepositoryResponse> {
    return this.remittanceRepository.getRemittanceItemsCount(params, refetch);
  }
}
